import type { InvoiceFullProductData } from '@/interfaces/billing'

export const getDecimalPlaces = (value: number): number => {
  if (!Number.isFinite(value)) return 0
  const [, decimals = ''] = value.toString().split('.')
  const trimmed = decimals.replace(/0+$/, '')
  return Math.min(trimmed.length, 3)
}

/**
 * Devuelve el número máximo de decimales permitidos para la cantidad
 * de un producto, teniendo en cuenta venta por peso y la medida.
 */
export const getQuantityDecimalsForProduct = (
  product: Pick<InvoiceFullProductData, 'saleByWeight' | 'measure'>,
  sampleQuantity?: number
): number => {
  const sampleDecimals =
    sampleQuantity !== undefined ? getDecimalPlaces(sampleQuantity) : 0

  const prefersWeightPrecision =
    product.saleByWeight || (product.measure && product.measure !== 'UNIT')

  const preferredDecimals = prefersWeightPrecision ? 3 : 2

  return Math.max(preferredDecimals, sampleDecimals)
}
